import React, { useState } from "react";
import profileImg from "../../assets/images/COOK-E.png";
import { format } from "date-fns";

import Swal from "sweetalert2";
import { playAudio } from "../../utils/btnAudio";
import { CButton } from "../../components/CommonComponents";
import { FaPen, FaPenSquare } from "react-icons/fa";
import EditProfile from "./EditProfile";
import { Switch } from "@nextui-org/react";

const UserProfileInfo = ({
  profile,
  uploadImage,
  editProfile,
  setVisibility,
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleFileChange = async (event) => {
    try {
      Swal.fire({
        icon: "success",
        title: "Uploading. It may take a few seconds to change",
        showConfirmButton: false,
        timer: 1500,
      });
      await uploadImage(event.target.files[0], profile.userId);
      // Optionally, refresh profile information here
    } catch (error) {
      alert("Failed to upload image");
    }
  };

  const handleEditData = (data) => {
    editProfile(data);
  };

  const handleVisibilityChange = (checked) => {
    playAudio();
    setVisibility(checked);
  };

  const createdAtDate = profile?.createdAt?.split("T")[0];
  console.log(profile, "pro");
  return (
    <>
      {profile && (
        <div className="flex flex-col w-full h-full mx-auto ">
          <div className="flex justify-between items-center mt-5 w-full h-12 rounded-lg transition-all duration-300">
            <div className="flex items-start flex-col md:flex-row justify-start md:items-center gap-3">
              <div className="text-black dark:text-white text-lg font-semibold">
                Profile Visibility
              </div>
              <button className="">
                <Switch
                  defaultChecked={profile?.visible}
                  onChange={handleVisibilityChange}
                  className=" ring-0 focus:ring-0 "
                  color="secondary"
                  classNames={{
                    wrapper: "bg-blue-500",
                  }}
                />
              </button>
            </div>

            <div></div>

            <CButton
              variant="red"
              className="ml-3"
              type="button"
              onClick={() => {
                playAudio();
                handleOpen();
              }}
            >
              Edit Profile
            </CButton>
          </div>
          {/* Profile Picture and Details */}
          <div className="flex md:flex-row flex-col  gap-4 mt-5 ">
            <div className="flex flex-col items-center w-full md:w-1/4 shrink-0  rounded-lg  transition-all duration-300">
              <img
                className="w-48 h-48 rounded-full object-cover border-4 border-white shadow-lg"
                src={profile?.photoURL || profileImg}
                alt="Profile"
              />
              <button
                className="-mt-6 ml-[30%] md:ml-[60%]  px-3 py-3 rounded-full bg-yellow-500 text-black shadow-lg hover:bg-yellow-600"
                onClick={() => {
                  playAudio();
                  document.getElementById("imageInput").click();
                }}
              >
                <input
                  type="file"
                  id="imageInput"
                  onChange={handleFileChange}
                  accept="image/*"
                  className="hidden"
                />
                <span className="text-xl">
                  <FaPen />
                </span>
              </button>
            </div>
            <div className="flex flex-col w-full md:w-1/2 text-center md:text-left text-black dark:text-white">
              <div className="mb-5">
                <span className="block text-2xl font-bold">User Name</span>
                <span className="block">{profile?.username}</span>
              </div>
              <div className="mb-5">
                <span className="block font-bold">Personal Name:</span>
                <span className="">{profile?.personalName}</span>
              </div>
              <div className="mb-5">
                <span className=" font-bold">Email: </span>
                <span className="">{profile?.email}</span>
              </div>
              <div className="mb-5">
                <span className=" font-bold">Joined:</span>
                <span className="">
                  {" "}
                  {profile?.createdAt?.split("T")[0]}
                  {/* {profile?.createdAt?.seconds
                    ? format(createdAtDate, "MMM dd, yyyy")
                    : "N/A"} */}
                </span>
              </div>
            </div>
          </div>
          <EditProfile
            open={open}
            handleClose={handleClose}
            onSubmit={handleEditData}
            formData={{
              username: profile?.username,
              personalName: profile?.personalName,
            }}
          />
        </div>
      )}
    </>
  );
};

export default UserProfileInfo;
